var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header',{staticClass:"jumbotron"},[_c('p',[_vm._v("Employee")]),_c('h3',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }